import { render } from "./Loader.vue?vue&type=template&id=2e0093ee"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=2e0093ee&lang=css"

import exportComponent from "/home/runner/work/nikidekor-frontend/nikidekor-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__